import i18next from 'i18next';

import type { Projects } from '@/features/projects/api/projects';

export const getFloorLabel = (floor: number) => {
  const suffix = getOrdinalSuffix(floor);

  if (floor === 0) {
    return i18next.t('ground-floor');
  }

  if (floor > 0) {
    return i18next.t('floor-with-suffix', { number: floor, suffix });
  }

  if (floor === -1) {
    return i18next.t('basement-floor');
  }

  if (floor < -1) {
    return i18next.t('basement-with-suffix', { number: floor, suffix });
  }
};

export const getProjectFloorLabel = (floor: Projects[number]['areaRooms']['floor'] | null) => {
  if (!floor || typeof floor.min !== 'number' || typeof floor.max !== 'number') {
    return '';
  }
  if (floor.min === floor.max) {
    return getFloorLabel(floor.min);
  }
  return `${getFloorLabel(floor.min)} - ${getFloorLabel(floor.max)}`;
};

const getOrdinalSuffix = (number: number) => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return 'th';
  }

  return suffixes[lastDigit] || 'th';
};
